import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, UntypedFormControl } from '@angular/forms';
import {
  StringCustomFieldConfig,
  SharedModule,
} from '@vendure/admin-ui/core';
import {
  CarouselArrowType,
  MobileBuyBannerType,
  TextValue,
} from '../../ui-types';

interface SiteStylesFormValue {
  displayHeaderMessage?: boolean;
  copyrightNotice?: TextValue;
  disclaimer?: TextValue;
  pdpAssetsArrowType?: CarouselArrowType;
  mobileBuyBannerType?: MobileBuyBannerType;
}

@Component({
  selector: 'site-style-form',
  templateUrl: './site-style-form.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class SiteStylesFormComponent implements OnInit {
  readonly: boolean;
  config: StringCustomFieldConfig;
  formControl: FormControl;

  displayHeaderMessageControl = new UntypedFormControl(true);
  disclaimerControl = new UntypedFormControl('');
  copyrightNoticeControl = new UntypedFormControl('');
  pdpAssetsArrowTypeControl = new UntypedFormControl(CarouselArrowType.LargeChevron);
  mobileBuyBannerTypeControl = new UntypedFormControl(MobileBuyBannerType.Regular);

  constructor(private changeDetector: ChangeDetectorRef) {}

  ngOnInit() {
    const initial = this.parseInitial(this.formControl?.value);
    this.displayHeaderMessageControl.setValue(initial.displayHeaderMessage ?? true, { emitEvent: false });
    this.copyrightNoticeControl.setValue(this.extractText(initial.copyrightNotice), { emitEvent: false });
    this.disclaimerControl.setValue(this.extractText(initial.disclaimer), { emitEvent: false });
    this.pdpAssetsArrowTypeControl.setValue(initial.pdpAssetsArrowType ?? CarouselArrowType.LargeChevron, { emitEvent: false });
    this.mobileBuyBannerTypeControl.setValue(initial.mobileBuyBannerType ?? MobileBuyBannerType.Regular, { emitEvent: false });

    this.displayHeaderMessageControl.valueChanges.subscribe(() => this.updateFormValue());
    this.copyrightNoticeControl.valueChanges.subscribe(() => this.updateFormValue());
    this.disclaimerControl.valueChanges.subscribe(() => this.updateFormValue());
    this.pdpAssetsArrowTypeControl.valueChanges.subscribe(() => this.updateFormValue());
    this.mobileBuyBannerTypeControl.valueChanges.subscribe(() => this.updateFormValue());

    this.changeDetector.markForCheck();
  }

  private parseInitial(value: unknown): SiteStylesFormValue {
    if (!value) {
      return {};
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      return value as SiteStylesFormValue;
    }

    return {};
  }

  private toTextValue(value: string): TextValue {
    return { format: 'rich', i18n: { en: value || '' } };
  }

  private extractText(value?: TextValue): string {
    return value?.i18n?.en || '';
  }

  private updateFormValue() {
    const next: SiteStylesFormValue = {
      displayHeaderMessage: !!this.displayHeaderMessageControl.value,
      copyrightNotice: this.toTextValue(this.copyrightNoticeControl.value || ''),
      disclaimer: this.toTextValue(this.disclaimerControl.value || ''),
      pdpAssetsArrowType: this.pdpAssetsArrowTypeControl.value || CarouselArrowType.LargeChevron,
      mobileBuyBannerType: this.mobileBuyBannerTypeControl.value || MobileBuyBannerType.Regular,
    };

    this.formControl.setValue(next);
    this.formControl.markAsDirty();
  }
}
